import { MainFilter } from 'components/tables/list-table/ListTableTypes';
import { t } from 'utils/getTranslations';
import { DATE_BASIS_SELECTOR, singleChoiceFilter } from '../reportFilters';

/** Which date the period bounds on an invoice: its invoice date (the report's default) or its service date. */
export function invoiceDateBasisFilter(): MainFilter {
    return singleChoiceFilter(DATE_BASIS_SELECTOR, 'reporting.filter.date-basis', [
        { label: t('reporting.filter.date-basis-invoice-date'), value: 'INVOICE_DATE' },
        { label: t('reporting.filter.date-basis-service-date'), value: 'SERVICE_DATE' },
    ]);
}
